<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<Serach @inputValue="inputValue"  />
			</div>
		</template>
		<el-table v-loading="loading" ref="multipleTable" :data="list.data" tooltip-effect="dark" style="width: 100%" :row-class-name="getRowClassName">
			<el-table-column type="expand">
				<template #default="scope">
					<el-form  label-position="left" inline class="demo-table-expand" v-for="(v,i) in scope.row.customer_address" :key="i">
						<el-form-item label="姓名">
							<span>
								{{v.customer_name}}
							</span>
						</el-form-item>
						<el-form-item label="邮编">
							<span>
								{{v.postcode}}
							</span>
						</el-form-item>
						<el-form-item label="电话">
							<span>
								{{v.phone}}
							</span>
						</el-form-item>
						<el-form-item label="地址">
							<span>
								{{v.street}}&nbsp;&nbsp;{{v.place_name}}&nbsp;&nbsp;{{v.city_name}}&nbsp;&nbsp;{{v.province_name}}
							</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="ID" align="center">
			</el-table-column>
			<el-table-column prop="username" label="客户姓名">
				<template v-slot="scope">
					{{scope.row.last_name}}&nbsp;&nbsp;{{scope.row.first_name}}
				</template>
			</el-table-column>
			<el-table-column prop="vip_name" label="会员等级" align="center">
				<template #default='scope'>
					<span v-if="scope.row.vip_grade">
						{{scope.row.vip_grade.description}}
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="customer_birth" label="生日" align="center">
			</el-table-column>
			<el-table-column prop="email" label="注册邮箱" align="center">
			</el-table-column>
			<el-table-column prop="created_at" label="注册时间" align="center">
			</el-table-column>
			<el-table-column prop="status" label="用户状态" align="center">
				<template v-slot="scope">
					<el-tag type="success" v-if="scope.row.status==1">正常</el-tag>
					<el-tag type="danger" v-if="scope.row.status==2">禁用</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="auto" align="center">
				<template #default="scope">
					<el-button type="primary" size="mini" @click="changeEnabled(scope.row)" v-if="scope.row.status==2">开启</el-button>
					<el-button type="danger" size="mini" @click="changeEnabled(scope.row)" v-if="scope.row.status==1">禁用</el-button>
					<el-button v-if="this.localGet('userId')==1" type="warning" size="mini" @click="delCustomer(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--总数超过一页，再展示分页器-->
				<pages :total="total" :page-size="pageSize" @handleSizeChangeSub="handleSizeChangeFun" @handleCurrentChangeSub="handleCurrentChangeFun"></pages>
	</el-card>
</template>

<script>
	import pages  from '../common/Pagination.vue'
	import Serach from '../common/Search.vue'
	export default {
		name: 'CustomerList',
		components:{
			pages,
			Serach
		},
		data() {
			return {
				list: [],
				loading: false,
				total:0,
				currentPage:1,
				pageSize:10,
			}
		},
		methods: {
			getRowClassName({row, rowIndex}){
				if(row.customer_address ==0){
					return 'row-expand-cover';
				}
			},
			inputValue (inpVal) {
				console.log(inpVal)
				this.httpPost({
					url: '/admin/customer/customer_list',
					data:{
						keywords: inpVal,
					}
				}).then((res)=>{
					this.list = res.data;
					this.total = res.data.total;
					this.currentPage = res.data.currentPage;
				})
				 
			},
			handleSizeChangeFun(page){
				this.pageSize = page;
				this.getCustomerList();
			},
			handleCurrentChangeFun(page){
				this.currentPage = page;
				let str = '';
				str = this.$route.path+'?p='+page;
				this.$router.push(str);
				this.getCustomerList();
			},
			getCustomerList() {

				this.httpPost({
					url: '/admin/customer/customer_list',
					data:{p:this.currentPage,routePath: this.$route.path},
				}).then((res) => {
					this.list = res.data;
					this.total = res.data.total;
					this.currentPage = res.data.currentPage;
				})

			},
			changeEnabled(val) {
				let select_id = val.id;
				let change_status = val.status;
				if (change_status == 1) {
					change_status = 2
				} else if (change_status == 2) {
					change_status = 1
				}
				// console.log(change_status);
				if (select_id) {
					this.loading = true;
					this.httpPost({
						url: '/admin/customer/change_status',
						data: {
							id: select_id,
							status: change_status
						}
					}).then((res) => {
						if (res.code == 1) {
							this.$message.success(res.msg);
							this.loading = false;
							this.getCustomerList();
						}
					})
				}
			},
			delCustomer(val) {
				let id = val.id;
				this.msgBoxAjax(
					'提示',
					'确定删除吗？',
					"/admin/customer/delCustomer", {
						id: id
					}).then((res) => {
					if (res.code == 1) {
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
				
							this.getCustomerList();
						});
					} else {
				
						this.messageCommon('错误', res.msg, 'error');
					}
				});

			}
		},
		created() {
			this.getCustomerList();
		}
	}
</script>

<style>
	.guest-container {
		min-height: 100%;
	}

	.el-card.is-always-shadow {
		min-height: 100% !important;
	}
	
  .row-expand-cover .el-table__expand-icon{visibility:hidden;}
</style>
